import React, { useState } from "react";
import { Form } from "react-bootstrap";
import loadable from "@loadable/component"
//import Select from 'react-select';

import { calculateMonthlyPayment, CalculatorFields, CalDefault } from "../../../common/utils/mortgage"
import { addCommas, numericWithDecimal } from "../../../common/utils/site_utlis"
import { currency } from "../../../common/constant"

const Select = loadable(() => import("react-select"));

const Mortgage = ({ price }) => {

    var down_payment = (20/100) * price;

    const [error_msg, setErrorMsg] = useState('');

    const [calculator_value, setCalculatorValue] = useState(
        {
            //'loan_amount': (price) - down_payment,
            'loan_amount': (price),
            'interest_rate': CalDefault.interest_rate,
            'amortization': CalDefault.amortization,
            'down_payment': down_payment
        }
    );

    const handleChange = (event, field_name) => {

        //console.log("event_target", event.value)

        if (parseFloat(numericWithDecimal(document.getElementById("down_payment").value)) > parseFloat(numericWithDecimal(document.getElementById("loan_amount").value))) {
            setErrorMsg("Down payment should not be greater than price.")
        } else {
            setErrorMsg("");
        }

        if (event?.target?.name === "interest_rate") {
            setCalculatorValue({ ...calculator_value, [event.target.name]: event.target.value > CalculatorFields.InterestMax ? CalculatorFields.InterestMax : numericWithDecimal(event.target.value) })
        } else {
            if (field_name === "amortization") {
                if (parseInt(event.value) > 35) {

                } else {
                    setCalculatorValue({ ...calculator_value, [field_name]: numericWithDecimal(event.value) })
                }
            } else {
                setCalculatorValue({ ...calculator_value, [event?.target?.name]: numericWithDecimal(event.target.value) })
            }
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'calculator',
            'formType': "Mortgage Calculator",
            'formName': "Mortgage Calculator",
            'formLabel': "Mortgage Calculator"
        });


    }

    const options = [
        { value: '25', label: '25 years' },
        { value: '30', label: '30 years' },
        { value: '35', label: '35 years' }
    ]

    var mortgage_monthly_payment = parseFloat(calculateMonthlyPayment(calculator_value.loan_amount, calculator_value.interest_rate, calculator_value.down_payment, calculator_value.amortization)).toFixed(2);

    return (
        <React.Fragment>
            <div className="tab-wrapper">
                <Form action="javascript:;">
                    {error_msg && <div className="alert alert-danger col-12 p-3">{error_msg}</div>}

                    <Form.Group className="form-wrap">
                        <Form.Label>Price ({currency})</Form.Label>
                        <Form.Control placeholder={""} type="text" name="loan_amount" id="loan_amount" value={addCommas(calculator_value.loan_amount)} onChange={handleChange} maxLength={CalculatorFields.PriceInputMax} />
                    </Form.Group>
                    <Form.Group className="form-wrap">
                        <Form.Label>Deposit ({currency})</Form.Label>
                        <Form.Control type="text" placeholder={"0"} name="down_payment" id="down_payment" value={addCommas(calculator_value.down_payment)} onChange={handleChange} maxLength={CalculatorFields.PriceInputMax} />
                    </Form.Group>
                    <Form.Group className="form-wrap">
                        <Form.Label>Repayment Term</Form.Label>
                        <Select options={options} placeholder="25 years" name="amortization" className="react-select form-control" classNamePrefix="react-select" onChange={(e) => handleChange(e, "amortization")} />
                    </Form.Group>
                    <Form.Group className="form-wrap">
                        <Form.Label>Interest Rate (%)</Form.Label>
                        <Form.Control className="sml_wdth" placeholder="0" type="text" name="interest_rate" value={numericWithDecimal(calculator_value.interest_rate)} onChange={handleChange} maxLength={CalculatorFields.InterestInputMax} />
                    </Form.Group>
                </Form>
                <div className="bottom-content">
                    <div className="sm-info">
                        <span className="bold-text">{currency}{parseInt(mortgage_monthly_payment) > 0 ? addCommas(mortgage_monthly_payment) : 0}</span>
                        <span className="time">per month
                        </span>
                    </div>
                    <p>These results are not provided by NatWest and are only indicative based on a repayment mortgage product. The interest rate has been assumed to stay the same for the selected mortgage term. Repayments will be subject to the product provided and your circumstances. Your home or property may be
                        repossessed if you do not keep up repayments on your mortgage.</p>
                </div>
            </div>
        </React.Fragment>
    );
};
export default Mortgage;